import { useCallback, useMemo, useReducer, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import { fetchInventoryList, transferInventory } from "../../../apis/inventory.api"
import MessageDilog from "../../../components/MessageDilog"
import { callApiAction } from "../../../store/actions/commonAction"
import { addInventoryListAction } from "../../../store/actions/invenotryListAction"
import { fetchInventoryCountAction } from "../../../store/actions/inventoryCountAction"
import { fetchLifeTimeStockCountAction } from "../../../store/actions/lifeTimeStockCountAction"
import { closeModal, openModal } from "../../../store/actions/modalAction"
import useValidate from "../../../store/hooks/useValidator"
import InventoryListReducer from "../../../store/reducers/InventoryListReducer"
import { getDateFiltersTime } from "../../../utils/helper"
import TransferBoxesUi from "./TransferBoxesUi"
import { invoicePaymentStatus } from "../../../utils/constants"

const TransferBoxesController = ({ title, callBack, defaultData = [], isFree }) => {
    const validate = useValidate()
    const params = useParams()
    const dispatch = useDispatch()
    const { inventoryCount, lifeStockCount } = useSelector(state => state)

    const [fields, setFields] = useState({
        defaultAmount: isFree ? 0 : 10000,
        err: '',
        defaultCategory: '',
        invoiceId: isFree?("FREE-"+new Date().getTime()):'',
        assignedTo: "",
        paid: invoicePaymentStatus.PAID,
        start: '',
        end: '',
        pageNo: 1,
        pageSize: 500,
        onlyBoxId: true,

        usercode: params.usercode
    })
    const [boxes, dispatchBoxes] = useReducer(InventoryListReducer, defaultData ?? [])

    const [loading, setLoading] = useState(false)


    const validationSchema = useMemo(() => ([

        {
            required: true,
            value: fields.start,
            field: 'Starting box Id ',
        },
        {
            required: true,
            value: fields.start,
            field: 'Last box Id',
        }
    ]), [fields])

    const onSelectRange = useCallback((e) => {
        e.preventDefault()
        const validationResponse = validate(validationSchema)

        if (validationResponse === true) {
            setLoading(true)
            dispatch(
                callApiAction(
                    async () => await fetchInventoryList(fields),
                    async (response) => {

                        const temp = response.result && Array.isArray(response.result) ? response.result : []
                        dispatchBoxes(addInventoryListAction(temp.length == 0 ? [] : temp.map((val) => (
                            { boxId: val.boxId, amount: fields.defaultAmount, category: fields.defaultCategory, selected: true }
                        ))))
                        setFields({ ...fields, err: '', start: '', end: '' })
                        setLoading(false)

                    },
                    (err) => {
                        setLoading(false)
                        setFields({ ...fields, err })
                    }
                )
            )
        } else {
            setFields({ ...fields, err: validationResponse })
        }


    }, [fields])


    const validationSchemaForFinaleSubmit = useMemo(() => ([

        {
            
            value: fields.defaultAmount,
            field: 'Amount ',
            custom:()=>{
                if(!fields.defaultAmount && isNaN(fields.defaultAmount)){
                    return "Amount is required"
                }
                return true
            }
        },
        {
            required: true,
            value: fields.defaultCategory,
            field: 'Category',
        },
        {
            required: true,
            value: fields.invoiceId,
            field: 'Invoice number',
        },
        {
            required: true,
            value: fields.assignedTo,
            field: 'Please Assign user',
        },
        {
            required: true,
            value: boxes,
            isArray: true,
            field: 'Boxes ',
        }
    ]), [fields, boxes])

    const onSubmit = useCallback((e) => {
        e.preventDefault()
        const validationResponse = validate(validationSchemaForFinaleSubmit)

        if (validationResponse === true) {
            setLoading(true)
            const transferableData = {
                devices: boxes.filter((val) => val.selected).map((val) => ({
                    boxId: val.boxId,
                    category: fields.defaultCategory,
                    paymentStatus: fields.paid,
                    amount: fields.defaultAmount
                })),
                usercode: params.usercode,
                invoiceId: fields.invoiceId,
                assignedTo: fields.assignedTo
            }

            dispatch(
                callApiAction(
                    async () => await transferInventory(transferableData),
                    async (response) => {

                        await callBack()

                        dispatch(fetchLifeTimeStockCountAction({ usercode: params.usercode }, () => { }, () => { }))
                        dispatch(fetchInventoryCountAction({ productCategory: params.productCategoryId, usercode: params.usercode, ...getDateFiltersTime(inventoryCount.filters.dateTime), ...inventoryCount.filters }, () => { }, () => { }))
                        dispatch(openModal(<MessageDilog title={"Device Transfer"} message="Devices transfered successfully." />, "sm"))

                    },
                    (err) => {
                        setLoading(false)
                        setFields({ ...fields, err })

                    }
                )
            )
        } else {
            setFields({ ...fields, err: validationResponse })
        }


    }, [fields, boxes])



    return <TransferBoxesUi
        isFree={isFree}
        boxes={boxes}
        dispatchBoxes={dispatchBoxes}
        setFields={setFields}
        loading={loading}
        fields={fields}
        title={title}
        onSubmit={onSubmit}
        onSelectRange={onSelectRange} />

}
export default TransferBoxesController